import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { selectTimeZone } from '../store/intl/selectors';
import { isAuthenticatedOrProspect } from '../store/session/selectors';
import { checkJoinability, query } from '../lib/game-utils/check-joinability';

export function useCheckJoinability({ gameId, gameType }) {
  const timeZone = useSelector(selectTimeZone);
  // A prospect too (2026-10-16): a Supercharger free member from her join
  // link is a phone number prospect, and the steps only know she's this
  // game's trial player (her number shown locked) from isPlayer.
  const loggedIn = useSelector(isAuthenticatedOrProspect);
  const skip = !gameId || !gameType || !timeZone;

  const { data, loading, error } = useQuery(query, {
    fetchPolicy: 'network-only',
    ssr: false,
    variables: { gameId, gameType, timeZone, isAuthenticated: loggedIn },
    skip,
  });
  const game = data?.game || {};

  if (loading || error || skip) return { error, loading };

  return checkJoinability(game);
}
